import React, {FC} from 'react';
import styled from 'styled-components';
import Icon, {IconSize} from '../Icon/Icon';
import {GenericIconName} from '../Icon/IconName';
import {darkGrayColor, primaryColor} from '../constants/colors';
import {fsXS, fwBold, fwMediumBold} from '../constants/typography';
import Card from './Card';
import CardLink from './CardLink';

const LinkLabel = styled.span<{bold?: boolean}>`
  font-size: ${fsXS}px;
  ${({bold}) => (bold ? fwBold : fwMediumBold)};
  line-height: 1.43;
  color: ${primaryColor};
`;

const StyledCardLink = styled(CardLink)`
  ${Card} {
    align-items: flex-start;
  }
`;

const GrayIcon = styled(Icon)`
  fill: ${darkGrayColor};
  margin-right: 5px;
`;

interface Props {
  to: string;
  label: string;
  className?: string;
  dataTestId?: string;
  bold?: boolean;
}

const QuestionCard: FC<Props> = ({to, bold, label, className, dataTestId}) => {
  return (
    <StyledCardLink data-testid={dataTestId} to={to} className={className}>
      <GrayIcon size={IconSize.S} asset={GenericIconName.IcQuestionFillAlt} />
      <LinkLabel bold={bold}>{label}</LinkLabel>
    </StyledCardLink>
  );
};

export default QuestionCard;
